// Global Instructions Rule Applied!

export const UPDATE_RECORD_BY_SEARCH = 'UPDATE_RECORD_BY_SEARCH'
